import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const selectShowSettings = createSelector([
	//TODO: in future multiple fields can be added in settings modal.
	(state: RootState) => state.QueryParams.data
],(qparamsState)=>{
	const {canEditSetback} = qparamsState;
	return !!canEditSetback;
});

export {
	selectShowSettings
};